export default "__VITE_ASSET__9FOmnFx5__"